import React, { FC } from 'react'
import { i18n } from '../../translate/i18n'
import { RoomStatus, RoomType, getStatusLabel, getTypeLabel } from '../../pages/Hospitality/HotelRoom/types'

const TestTranslations: FC = () => {
  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang)
  }

  const statusOptions = Object.values(RoomStatus)
  const typeOptions = Object.values(RoomType)

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h2>Teste de Traduções - Hotel Room</h2>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>Alterar Idioma:</h3>
        <button onClick={() => changeLanguage('pt')} style={{ margin: '5px', padding: '5px 10px' }}>
          Português
        </button>
        <button onClick={() => changeLanguage('en')} style={{ margin: '5px', padding: '5px 10px' }}>
          English
        </button>
        <button onClick={() => changeLanguage('es')} style={{ margin: '5px', padding: '5px 10px' }}>
          Español
        </button>
        <button onClick={() => changeLanguage('fr')} style={{ margin: '5px', padding: '5px 10px' }}>
          Français
        </button>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>Rótulos (Labels):</h3>
        <p><strong>Número do Quarto:</strong> {i18n.t('hotelRoom.labels.roomNumber')}</p>
        <p><strong>Status:</strong> {i18n.t('hotelRoom.labels.status')}</p>
        <p><strong>Capacidade:</strong> {i18n.t('hotelRoom.labels.capacity')}</p>
        <p><strong>Preço:</strong> {i18n.t('hotelRoom.labels.price')}</p>
        <p><strong>Tipo do Quarto:</strong> {i18n.t('hotelRoom.labels.type')}</p>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>Status do Quarto:</h3>
        {statusOptions.map(status => (
          <p key={status}>
            <strong>{status}:</strong> {getStatusLabel(status)}
          </p>
        ))}
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>Tipos de Quarto:</h3>
        {typeOptions.map(type => (
          <p key={type}>
            <strong>{type}:</strong> {getTypeLabel(type)}
          </p>
        ))}
      </div>

      <div style={{ marginTop: '30px', padding: '10px', backgroundColor: '#f0f0f0', borderRadius: '5px' }}>
        <p><strong>Idioma atual:</strong> {i18n.language}</p>
      </div>
    </div>
  )
}

export { TestTranslations }